import { useEffect, useState } from 'react';
import { Box, HStack, useMediaQuery } from 'native-base';
import { isUndefined, padStart } from 'lodash';
import moment, { Duration } from 'moment';
import { useTranslation } from 'react-i18next';

import { Text } from '@pimm/base';
import { useAppLocale } from '@pimm/common';
import { DayBlock, useSiteTime } from '@app/features/store-core';

export const DayblockCountdown = () => {
  const { t } = useTranslation();
  const [isTabletScreen] = useMediaQuery({ maxWidth: 1200 });
  const { translate } = useAppLocale();
  const siteTime = useSiteTime();
  const [dayBlock, setDayBlock] = useState<DayBlock>();
  const [countdown, setCountdown] = useState<Duration>();

  const title = translate(dayBlock?.title, dayBlock?.titleTranslations).toLocaleUpperCase();

  useEffect(() => {
    if (!isUndefined(siteTime.utcOffsetInMinutes)) {
      setDayBlock(siteTime.toDayBlockNow());
    }
  }, [siteTime.utcOffsetInMinutes]);

  // Responsible for countdown effect
  useEffect(() => {
    let interval;

    if (dayBlock) {
      interval = setInterval(() => {
        const diff = dayBlock.endTime!.getTime() - siteTime.today().getTime();
        const duration: Duration = moment.duration(diff, 'milliseconds');

        if (duration.asMilliseconds() > 0) {
          setCountdown(duration);
        } else {
          clearInterval(interval);
          setDayBlock(siteTime.toDayBlockNow());
        }
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [dayBlock]);

  if (!dayBlock) return null;

  return (
    <HStack alignItems="center" space={2}>
      {!!title && (
        <HStack space={1} alignItems="center">
          <Text color="black" size={{ base: 'sm', xl: 'md' }} fontWeight={800} lineHeight="xs" textAlign="right">
            {`${title}${isTabletScreen ? '\n' : ' '}`}
            <Text color="black" size={{ base: 'sm', xl: 'md' }} fontWeight={500}>
              {t('store_core:ends_in')}
            </Text>
          </Text>
        </HStack>
      )}
      <HStack space={{ base: 0.5, xl: 1 }} alignItems="center">
        <Box w={6} h={6} borderRadius="md" justifyContent="center" bgColor="white">
          <Text size="md" fontWeight={700} color="black" textAlign="center" lineHeight="xs">
            {padStart(`${countdown?.hours() ?? ''}`, 2, '0')}
          </Text>
        </Box>
        <Text color="black" size="md" fontWeight={700}>
          :
        </Text>
        <Box w={6} h={6} borderRadius="md" justifyContent="center" bgColor="white">
          <Text size="md" fontWeight={700} color="black" textAlign="center" lineHeight="xs">
            {padStart(`${countdown?.minutes() ?? ''}`, 2, '0')}
          </Text>
        </Box>
        <Text color="black" size="md" fontWeight={700}>
          :
        </Text>
        <Box w={6} h={6} borderRadius="md" justifyContent="center" bgColor="white">
          <Text size="md" fontWeight={700} color="black" textAlign="center" lineHeight="xs">
            {padStart(`${countdown?.seconds() ?? ''}`, 2, '0')}
          </Text>
        </Box>
      </HStack>
    </HStack>
  );
};
